import { styled } from '@tools/wr-catalog-base'

export const ProductsCart = styled.div`
  flex: 3;
  transition: flex 250ms linear;
  align-self: flex-start;
`

export const CartHeader = styled.div`
  text-align: left;
`

export const CartTotal = styled.span`
  font-weight: 800;
  padding-left: 5px;
`

export const ModalDescription = styled.p`
  padding: 20px;
  text-align: center;
`
